import { areaCardsInfoQuery, defaultCardQuery } from "@/api/queries";
import { StatCard } from "@/components/StatCard";
import { UilExchangeAlt } from "@iconscout/react-unicons";
import { useMediaQuery } from "@react-hookz/web";
import { useAtomValue } from "jotai";
import { Fragment, useEffect, useState } from "react";

const cardTypes = ["first", "second", "national"];

export const CardList = () => {
  const isMobileDevice = useMediaQuery("(max-device-width: 480px)");

  const areaCards = useAtomValue(areaCardsInfoQuery);
  const defaultCard = useAtomValue(defaultCardQuery);

  const [prevData, setPrevData] = useState<any[]>([]);

  const data = areaCards.state === "hasData" ? areaCards.data : prevData;
  const defaultCardData = defaultCard.state === "hasData" ? defaultCard.data : [];

  const isDefault = data[0]?.name === "United Kingdom";
  const cards = data.filter((area) => area?.name);

  useEffect(() => {
    if (areaCards.state === "loading") return;

    if (data !== prevData) {
      setPrevData(data);
    }
  }, [data]);

  return (
    <Fragment>
      {cards
        .filter((area) => area?.name !== "National Average" || !isDefault)
        .map((area, index) => {
          const title = isDefault ? "This year" : area?.name;
          const type = isDefault ? "default" : cardTypes[index];

          return (
            <Fragment key={area.name}>
              <StatCard
                index={index}
                title={title}
                count={area.total ?? area.average}
                change={area.change}
                rate={area.rate}
                length={cards.length}
                isFull={index === 2}
                type={area.name !== "National Average" ? type : "national"}
              />
              {index === 0 && area.name !== "National Average" && !isMobileDevice && (
                <UilExchangeAlt className="text-white" />
              )}
            </Fragment>
          );
        })}
      {isDefault && defaultCardData?.month && (
        <StatCard
          key={"Last month"}
          title={defaultCardData.month}
          count={defaultCardData.total}
          rate={defaultCardData.rate}
          type="default"
        />
      )}
    </Fragment>
  );
};
